<script lang="ts">
export default {
  name: 'KkSelectStore',
}
</script>

<script lang="ts" setup>
import { useI18n } from 'vue-i18n'
import { KkBox } from '../../base'
import { KkAddLabel } from '../../ui'

export interface Props {
  selectedStoreCount: number
  title?: string
  targetStoreLabel?: string
  disabled?: boolean
}

export interface Emits {
  (key: 'open-store-modal'): void
}

const props = withDefaults(defineProps<Props>(), {
  title: '',
  targetStoreLabel: '',
})
const emits = defineEmits<Emits>()
const { t } = useI18n()

const selectStoresLength = (selectedStoreCount: number) => {
  return selectedStoreCount !== 0
    ? t('pages.CompaniesStorePost.selectStoresCount', { count: selectedStoreCount })
    : t('messages.notSelected')
}
</script>

<template>
  <KkBox border>
    <template #content>
      <h3>{{ props.title }}</h3>
      <p>{{ props.targetStoreLabel }}：<span class="select-store">{{ selectStoresLength(props.selectedStoreCount) }}</span></p>

      <div class="addLabelWrapper">
        <KkAddLabel
          :disabled="props.disabled"
          :label="t('messages.selectStores')"
          @click="emits('open-store-modal')"
        />
      </div>
      <slot />
    </template>
  </KkBox>
</template>

<style lang="scss" scoped>
@import "../../../../../stylesheets/biz_spa/foundation/_var.scss";
.select-store {
  font-weight: bold;
}
.addLabelWrapper {
  margin-top: 16px;
}
</style>
